import React from "react";

const SvgNapoveda = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <path
      d="M95.37 104.08a72.25 72.25 0 0111.3-12.25 62 62 0 008.45-8.77 13.79 13.79 0 002.77-8.45 12.9 12.9 0 00-5.37-10.74q-5.38-4.11-14.38-4.11-17.07 0-25.76 12.16L57.06 62A44.41 44.41 0 0174.6 47.67q10.74-5 25.28-5 17.69 0 28.2 7.67t10.51 21.09a28.35 28.35 0 01-2.14 11.38 31.21 31.21 0 01-5.13 8.29 103.17 103.17 0 01-7.9 7.82 60.57 60.57 0 00-8.93 9.48 16.46 16.46 0 00-2.92 9.8H91.5q0-8.51 3.87-14.12zm-2.84 48.34a11.89 11.89 0 01-3.53-8.76 11.64 11.64 0 013.53-8.66 12.44 12.44 0 019.08-3.48 12.25 12.25 0 018.93 3.48 11.64 11.64 0 013.56 8.69 11.89 11.89 0 01-3.56 8.76 12.08 12.08 0 01-8.93 3.56 12.27 12.27 0 01-9.08-3.59z"
      data-name="Horn\xED menu + Footer"
    />
  </svg>
);

export default SvgNapoveda;

